import { request } from '@/api/apiUtils';
import type { EntityDefinition, FetcherEntry } from '@/data/types';
import type { IFountainAct, ResponseType } from '@/types';

/** Root: query-key prefix for this entity's slice of the cache (ADR 0010) */
export const FOUNTAIN_ACTS_ROOT = ['fountain', 'acts'] as const;

interface ActsListParams {
    projectId: number;
    version?: string;
}

const fetchers = {
    list: {
        key: ({ projectId, version }: ActsListParams) =>
            [...FOUNTAIN_ACTS_ROOT, version !== undefined ? { projectId, version } : { projectId }] as const,
        fetch: async ({ projectId, version }: ActsListParams): Promise<IFountainAct[]> => {
            const params = new URLSearchParams();
            params.append('with', 'tags.subject');
            if (version) params.append('version', version);
            const data: ResponseType<IFountainAct[]> = await request(`projects/${projectId}/acts?${params}`);
            return data.data;
        },
    },
    // biome-ignore lint/suspicious/noExplicitAny: required for generic type inference
} satisfies Record<string, FetcherEntry<any, any>>;

export const actsEntity: EntityDefinition<typeof fetchers> = {
    name: 'acts',
    roots: [FOUNTAIN_ACTS_ROOT],
    fetchers,
};

export type { ActsListParams };
